module.exports = __webpack_public_path__ + "img/nodejs.f434bfbb.svg";